/**
 * [AI GENERATED CODE]
 * Automatic session-based browser cache prevention utility
 * This prevents back/forward cache loading during critical authentication flows
 * Automatically manages critical flow state based on URL paths
 */

// Define critical authentication flow paths
const CRITICAL_FLOW_ENTRY_PATHS = [
  '/teacher/verify-otp',
  '/teacher/complete-registration',
  '/classes/add'
];

const CRITICAL_FLOW_EXIT_PATHS = [
  '/classes/',  // Any class-specific path (e.g., /classes/{slug}/students/add)
  '/teacher/',  // Any teacher-specific path after completion
];

/**
 * Check if current path should enter critical flow
 */
const shouldEnterCriticalFlow = (path: string): boolean => {
  return CRITICAL_FLOW_ENTRY_PATHS.some(criticalPath => path.includes(criticalPath));
};

/**
 * Check if current path should exit critical flow
 */
const shouldExitCriticalFlow = (path: string): boolean => {
  return CRITICAL_FLOW_EXIT_PATHS.some(exitPath => path.includes(exitPath)) &&
         !shouldEnterCriticalFlow(path); // Don't exit if still in entry path
};

/**
 * Automatically manage critical flow based on current path
 */
const manageCriticalFlow = (): void => {
  const currentPath = window.location.pathname;
  const inCriticalFlow = sessionStorage.getItem('inCriticalAuthFlow') === 'true';

  if (shouldEnterCriticalFlow(currentPath) && !inCriticalFlow) {
      // For other entry paths like /classes/add or /teacher/complete-registration
      sessionStorage.setItem('inCriticalAuthFlow', 'true');
  } else if (shouldExitCriticalFlow(currentPath) && inCriticalFlow) {
    sessionStorage.removeItem('inCriticalAuthFlow');
    // console.log('Critical auth flow completed - cache prevention disabled');
  }
};

/**
 * Initializes global cache prevention with automatic flow management
 * Call this once in your app's entry point
 */
export const initGlobalCachePrevention = (): void => {
  // console.log('Initializing automatic session-based cache prevention...');
  
  // Manage critical flow on initial load
  manageCriticalFlow();
  
  // Listen for pageshow events (cache detection)
  window.addEventListener('pageshow', function(event: PageTransitionEvent) {
    // console.log('Global pageshow event fired, persisted:', event.persisted, 'path:', window.location.pathname);
    
    if (event.persisted && sessionStorage.getItem('inCriticalAuthFlow')) {
      // console.log("In critical auth flow - reloading cached page");
      window.location.reload();
    } else {
      // Manage critical flow on every page show (including navigation)
      manageCriticalFlow();
    }
  });
  
  // Listen for popstate events (browser navigation)
  window.addEventListener('popstate', function() {
    setTimeout(() => manageCriticalFlow(), 0); // Delay to ensure URL is updated
  });
  
  // console.log('Automatic session-based cache prevention initialized');
};